import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { Text } from '@sitecore-jss/sitecore-jss-react'
import Modal from 'react-modal'
import { ModalProps } from '../../types/types'
import './styles.scss'

const ModalDialog = ({
  isOpen = false,
  close,
  children,
  shouldCloseOnOverlayClick = true,
  title,
  className,
  hasMaxHeightRestricted = false,
}: ModalProps) => {
  const [overlayDiv, setOverlayDiv] = useState<HTMLDivElement | null>(null)
  const closeModal = () => {
    close && close(false)
  }

  const CloseButton = () => (
    <button className="my-modal-dialog__close-button" onClick={closeModal}>
      <pfe-icon icon="cnh-close" size={'24'} color={'base'} />
    </button>
  )

  return (
    <Modal
      isOpen={isOpen}
      parentSelector={() => document && document.querySelector('#root')}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      className={`my-modal-dialog ${className} ${
        hasMaxHeightRestricted ? 'my-modal-dialog--has-max-height' : ''
      }`}
      overlayClassName={`my-modal-dialog__overlay ${className} ${
        hasMaxHeightRestricted ? 'my-modal-dialog__overlay--has-max-height' : ''
      }`}
      appElement={
        typeof document !== 'undefined' ? document.querySelector('#root') : null
      }
      overlayRef={setOverlayDiv}
    >
      {overlayDiv && ReactDOM.createPortal(<CloseButton />, overlayDiv)}
      {title && (
        <Text tag="h2" field={title} className="my-modal-dialog__title" />
      )}
      {children}
    </Modal>
  )
}
export default ModalDialog
